import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;

  ${props => props.selectable && `cursor: pointer;`}

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
`;
const Bullet = styled.div`
  margin-right: 10px;
  line-height: 22px;
`;
const Time = styled.div`
  color: #0097ff;
  width: 80px;
  font-variant-numeric: tabular-nums;
`;
const Separator = styled.div`
  margin-left: 5px;
  margin-right: 10px;
`;
const Title = styled.div``;

const TableOfContents = ({ contents, selectable, onSelect }) => {
  return (
    <>
      {_.map(contents, content => (
        <Container
          onClick={() => selectable && onSelect && onSelect(content)}
          selectable={selectable}
        >
          <Bullet>•</Bullet>
          <Time>{content.time}</Time>
          <Separator>-</Separator>
          <Title>{content.title}</Title>
        </Container>
      ))}
    </>
  );
};

TableOfContents.propTypes = {
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      time: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  selectable: PropTypes.bool,
  onSelect: PropTypes.func,
};

TableOfContents.defaultProps = {
  contents: [],
  selectable: false,
  onSelect: () => {},
};

export default TableOfContents;
